var questions = document.getElementsByClassName('faq-accordion-question');
if (questions.length !== 0) {
  var firstAnswer = questions[0].nextElementSibling;
  firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
  
  for (var i = 0; i < questions.length; i++) {
  
      questions[i].addEventListener('click', function () {
          this.classList.toggle('active');
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
              panel.style.maxHeight = null;
            } else {
              panel.style.maxHeight = panel.scrollHeight + "px";
            }
      })
  }
}